const $ = require('jquery');
window.$ = window.jQuery = $;
module.exports = $;
